package nl.volleyplanner.web

import kotlinx.coroutines.*
import kotlin.random.Random

class AsyncOperation<T>(
    val scope: CoroutineScope,
    private val block: suspend () -> T
) {
    private var onCompleteHandler: ((T) -> Unit)? = null
    private var onErrorHandler: ((Throwable) -> Unit)? = null

    private val _job: Job = scope.launch {
        try {
            val result = block()
            withContext(Dispatchers.Main) {
                onCompleteHandler?.invoke(result)
            }
        } catch (e: Throwable) {
            withContext(Dispatchers.Main) {
                console.log("Error during async operation: ${e.message}")
                e.printStackTrace()
                onErrorHandler?.invoke(e)
            }
        }
    }

    fun cancel() {
        _job.cancel()
    }

    fun onComplete(handler: (T) -> Unit) : AsyncOperation<T> {
        onCompleteHandler = handler
        return this
    }

    fun onError(handler: (Throwable) -> Unit) : AsyncOperation<T> {
        onErrorHandler = handler
        return this
    }
}

fun <T> launchAsync(
    coroutineScope: CoroutineScope = CoroutineManager.DISPATCHER_SCOPE,
    block: suspend () -> T
) : AsyncOperation<T> = AsyncOperation(coroutineScope, block)